import { render } from "./Pokemon.vue?vue&type=template&id=3418cfce"
import script from "./Pokemon.vue?vue&type=script&lang=js"
export * from "./Pokemon.vue?vue&type=script&lang=js"

import "./Pokemon.vue?vue&type=style&index=0&id=3418cfce&lang=css"
script.render = render

export default script